import { useCallback, useEffect, useState } from "react";

import { dashboardService } from "../sevices/dashboard.service";
import { SparePartsDashboardData } from "../Dashboard.types";

export const useDashboard = () => {
  const [data, setData] = useState<SparePartsDashboardData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchDashboard = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const result = await dashboardService.getDashboardData();
      setData(result);
    } catch (err: any) {
      setError(
        err?.response?.data?.message ||
          err?.message ||
          "Unable to load Spare Parts dashboard"
      );
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchDashboard();
  }, [fetchDashboard]);

  return {
    data,
    loading,
    error,
    refetch: fetchDashboard,
  };
};
